import VueRouter, { RouteConfig } from 'vue-router'

/** 使用 require.context() 动态加载路由 */
const moduleLoader = require.context('./modules', false, /-routes$/)
const routes: Array<RouteConfig> = moduleLoader
    .keys()
    .map((key) => {
        return moduleLoader(key).default
    })
    .reduce((routes, m) => routes.concat(m), []) // 合并路由

/** 导出创建路由模块方法 */
export const createRouter = () => {
    /** 加载路由模块 */
    const router = new VueRouter({ mode: 'history', base: '/', routes })
    return router
}
